export default __webpack_public_path__ + "static/StM_Application_form_scholarship-4b1d2cac87003a358ffaae30d423efda.pdf";